import { SchedulerLazyLoadingPlugin } from "../../internals/plugins/SchedulerLazyLoadingPlugin.mjs";
export class EventTimelinePremiumLazyLoadingPlugin extends SchedulerLazyLoadingPlugin {}